var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from 'react';
import { useDisclosure } from 'shared/components';
import { IFrameHeaderContainer } from '../components/iframeHeaderContainer';
import { IFrameWarning } from '../components/iframeWarning';
import { IFrameCloseButton } from '../components/iframeCloseButton';
export var IFramePageContextActionTypes;
(function (IFramePageContextActionTypes) {
    IFramePageContextActionTypes[IFramePageContextActionTypes["SET_HEADER"] = 0] = "SET_HEADER";
    IFramePageContextActionTypes[IFramePageContextActionTypes["SET_HEADER_CONTAINER"] = 1] = "SET_HEADER_CONTAINER";
    IFramePageContextActionTypes[IFramePageContextActionTypes["SET_IFRAME_URL"] = 2] = "SET_IFRAME_URL";
    IFramePageContextActionTypes[IFramePageContextActionTypes["SET_CLOSE_BUTTON"] = 3] = "SET_CLOSE_BUTTON";
    IFramePageContextActionTypes[IFramePageContextActionTypes["SET_ON_CLOSE"] = 4] = "SET_ON_CLOSE";
    IFramePageContextActionTypes[IFramePageContextActionTypes["SET_IS_LOADING"] = 5] = "SET_IS_LOADING";
})(IFramePageContextActionTypes || (IFramePageContextActionTypes = {}));
export var iframePageInitialState = {
    disclosure: { isOpen: false },
    header: function () { return (_jsx(IFrameWarning, { children: "All changes must be saved within this window before closing." })); },
    headerContainer: IFrameHeaderContainer,
    closeButton: IFrameCloseButton,
    onClose: null,
    iframeUrl: null,
    isLoading: false,
};
export var iframePageContext = createContext({
    state: iframePageInitialState,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    dispatch: function () { },
});
export var IFramePageProvider = function (_a) {
    var children = _a.children;
    var disclosure = useDisclosure();
    var _b = useReducer(function (state, action) {
        switch (action.type) {
            case IFramePageContextActionTypes.SET_HEADER:
                return __assign(__assign({}, state), { header: action.payload });
            case IFramePageContextActionTypes.SET_HEADER_CONTAINER:
                return __assign(__assign({}, state), { headerContainer: action.payload });
            case IFramePageContextActionTypes.SET_IFRAME_URL:
                return __assign(__assign({}, state), { iframeUrl: action.payload });
            case IFramePageContextActionTypes.SET_CLOSE_BUTTON:
                return __assign(__assign({}, state), { closeButton: action.payload });
            case IFramePageContextActionTypes.SET_ON_CLOSE:
                return __assign(__assign({}, state), { onClose: action.payload });
            case IFramePageContextActionTypes.SET_IS_LOADING:
                return __assign(__assign({}, state), { isLoading: action.payload });
            default:
                throw new Error('Invalid action');
        }
    }, iframePageInitialState), state = _b[0], dispatch = _b[1];
    return (_jsx(iframePageContext.Provider, __assign({ value: { state: __assign(__assign({}, state), { disclosure: disclosure }), dispatch: dispatch } }, { children: children })));
};
export var useIFramePageContext = function () {
    var context = useContext(iframePageContext);
    var dispatch = context.dispatch;
    if (context === undefined) {
        throw new Error('useIFramePageContext must be used within a IFramePageProvider');
    }
    var setHeader = function (payload) {
        dispatch({ type: IFramePageContextActionTypes.SET_HEADER, payload: payload });
    };
    var setHeaderContainer = function (payload) {
        dispatch({ type: IFramePageContextActionTypes.SET_HEADER_CONTAINER, payload: payload });
    };
    var setIFrameUrl = function (payload) {
        dispatch({ type: IFramePageContextActionTypes.SET_IFRAME_URL, payload: payload });
    };
    var setCloseButton = function (payload) {
        dispatch({ type: IFramePageContextActionTypes.SET_CLOSE_BUTTON, payload: payload });
    };
    var setOnClose = function (payload) {
        dispatch({ type: IFramePageContextActionTypes.SET_ON_CLOSE, payload: payload });
    };
    var setIsLoading = function (payload) {
        dispatch({ type: IFramePageContextActionTypes.SET_IS_LOADING, payload: payload });
    };
    return __assign(__assign(__assign({}, context), context.state), { setHeader: setHeader, setHeaderContainer: setHeaderContainer, setIFrameUrl: setIFrameUrl, setCloseButton: setCloseButton, setOnClose: setOnClose, setIsLoading: setIsLoading });
};
